const LOCALHOST = 'localhost';
const IPV4_LABEL_COUNT = 4;
const NUMERIC_LABEL_PATTERN = /^\d+$/;

export const isLocalDevHost = (hostname: string) => {
  const labels = hostname.split('.');
  const isIpv4 =
    labels.length === IPV4_LABEL_COUNT &&
    labels.every((label) => NUMERIC_LABEL_PATTERN.test(label));
  return (
    hostname === LOCALHOST || hostname.endsWith(`.${LOCALHOST}`) || isIpv4 || hostname.includes(':')
  );
};
